module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-user--white-700fdac77cd148839b8b5afe36d538f2.svg";